// extracted by mini-css-extract-plugin
export default {"container":"modal_container__mx-db","card":"modal_card__FO8F9","btn_container":"modal_btn_container__lVIv8"};